import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 13.5C6.59976 13.7997 6.59971 13.7996 6.59965 13.7995L6.59944 13.7992L6.59871 13.7983L6.59603 13.7947L6.5859 13.7811L6.54726 13.7289C6.51362 13.6834 6.46455 13.6166 6.40226 13.531C6.27771 13.3597 6.10018 13.1128 5.88733 12.8089C5.46196 12.2015 4.89394 11.3644 4.3251 10.4473C3.75731 9.53191 3.1831 8.52788 2.74919 7.58821C2.32411 6.66769 2 5.73962 2 5C2 3.67392 2.52678 2.40215 3.46447 1.46447C4.40215 0.526784 5.67392 0 7 0C8.32608 0 9.59785 0.526784 10.5355 1.46447C11.4732 2.40215 12 3.67392 12 5C12 5.73962 11.6759 6.66769 11.2508 7.58821C10.8169 8.52788 10.2427 9.53191 9.6749 10.4473C9.10606 11.3644 8.53804 12.2015 8.11267 12.8089C7.89982 13.1128 7.72229 13.3597 7.59774 13.531C7.53545 13.6166 7.48638 13.6834 7.45274 13.7289L7.4141 13.7811L7.40397 13.7947L7.40129 13.7983L7.40056 13.7992L7.40035 13.7995C7.40029 13.7996 7.40024 13.7997 7 13.5ZM7 13.5L7.40024 13.7997C7.30583 13.9258 7.15752 14 7 14C6.84248 14 6.69417 13.9258 6.59976 13.7997L7 13.5ZM8.62189 4.99997C8.62189 5.89573 7.89573 6.62189 6.99997 6.62189C6.10421 6.62189 5.37805 5.89573 5.37805 4.99997C5.37805 4.10421 6.10421 3.37805 6.99997 3.37805C7.89573 3.37805 8.62189 4.10421 8.62189 4.99997Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }